import { useNavigate } from "react-router";
import axiosInstance from "../../axios/axios";
const isTestApp = process.env.REACT_APP_IS_TEST;
const logoutUAEPASS = process.env.REACT_APP_UAE_PASS_LOGOUT_LINK;
const RedirectUAEPASS = process.env.REACT_APP_UAE_PASS_REDIRECT_LINK;

export function getProfile() {
    return new Promise((resolve, reject) => {
        axiosInstance.get("/account/profile").then(userProfile => {
            if (userProfile.data.status.detailedResponseCode !== "Success") {
                reject(false)
            } else {
                resolve(userProfile?.data)
            }
        }).catch(error => reject(false))
    })
}

export function handlelogout() {
    localStorage.clear();
    if (isTestApp == "false") {
        lougoutUaePass();
    }
}

export function updateAccount(obj) {
    const formData = new FormData();

    function appendIfNotNull(key, value) {
        if (value !== null && value !== undefined && value !== "") {
            formData.append(key, value);
        }
    }

    appendIfNotNull('Id', localStorage.getItem('currentSubAccountId'));
    appendIfNotNull('Email', obj?.email);
    appendIfNotNull('MobileNo', obj?.mobileNo);
    appendIfNotNull('SecondEmail', obj?.secondEmail);
    appendIfNotNull('PhoneNo', obj?.phoneNo);
    appendIfNotNull('SecondMobileNo', obj?.secondMobileNo);
    appendIfNotNull('Signature', obj?.signature);
    appendIfNotNull('TableType', obj?.tableType);
    appendIfNotNull('Iban', obj?.iban);
    appendIfNotNull('BankName', obj?.bankName);
    appendIfNotNull('BneficiaryName', obj?.bneficiaryName);
    appendIfNotNull('BankAccountNumber', obj?.bankAccountNumber);
    appendIfNotNull('CurrencyId', obj?.currencyId);
    appendIfNotNull('BankCountryId', obj?.bankCountryId);
    appendIfNotNull('SwiftCode', obj?.swiftCode);
    appendIfNotNull('IsAgent', obj?.isAgent);
    appendIfNotNull('IsHandler', obj?.isHandler);
    appendIfNotNull('HandlerFile', obj?.handlerFile);
    appendIfNotNull('NationalIdFile', obj?.nationalIdFile);
    appendIfNotNull('ProfileImageFile', obj?.profileImageFile);
    appendIfNotNull('TrcFile', obj?.trcFile);
    appendIfNotNull('Trn', obj?.trn);
    appendIfNotNull('HasTrn', obj?.hasTrn);


    return new Promise((resolve, reject) => {
        axiosInstance.post("/ownerprofile/updateownerappuseraccount", formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                resolve(res)
            }).catch(error => reject(false))
    })
}


export function lougoutUaePass() {
    try {
        window.location.href = `${logoutUAEPASS}?redirect_uri=${RedirectUAEPASS}`;
        localStorage.setItem("EAHSUserIsUAEPASSUser", false);
    } catch (error) {
        console.log("error in logout in UAE PASS", error);
    }
}
export function verfyEmail(otp) {
    return new Promise((resolve, reject) => {
        axiosInstance.post("/account/confirmemail", { otp: otp }).then(res => {
            resolve(res)
        }).catch(error => reject(false))
    })
}
